import { getCookie, setCookie } from '@cnamts/accessmaster-jwt/utils';

const jwtTokenManager = {
	/**
	 * Fonction qui renvoie le token persisté dans un cookie, ou `null` s'il n'existe pas.
	 */
	getToken(tokenCookieName: string): string | null {
		const token = getCookie(tokenCookieName);

		return token !== '' ? token : null;
	},

	/**
	 * Renvoie `true` si l'utilisateur est connecté, `false` sinon.
	 */
	isLoggedIn(tokenCookieName: string): boolean {
		return this.getToken(tokenCookieName) !== null;
	},

	/**
	 * Fonction qui persiste le token dans un cookie.
	 */
	saveToken(jtwToken: string, tokenCookieName: string): void {
		setCookie(tokenCookieName, jtwToken, 1, false);
	},

	/**
	 * Fonction qui persiste le token dans un cookie.
	 */
	deleteToken(tokenCookieName: string): void {
		setCookie(tokenCookieName, '', -1, false);
	}
};

export default jwtTokenManager;
